/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует поток изменений ресурсов домена Телеметрии
 */

/**
 * Справочник типа архивности показаний.
 * Используется для указания за какой период произошло измерение
 */
export enum CollectorParamsArchiveType {
  /**
   * Значение не указано
   */
  ARCHIVE_TYPE_UNKNOWN = "ARCHIVE_TYPE_UNKNOWN",
  /**
   * Текущие показания
   */
  CURRENT = "CURRENT",
  /**
   * За 30 мин
   */
  HALFHOUR = "HALFHOUR",
  /**
   * За час
   */
  HOUR = "HOUR",
  /**
   * За сутки
   */
  DAY = "DAY",
  /**
   * За месяц
   */
  MONTH = "MONTH",
  /**
   * За год
   */
  YEAR = "YEAR",
}
/**
 * Справочник типа архивности показаний.
 * Используется для указания за какой период произошло измерение
 */
export type CollectorParamsArchiveTypeResponseEnum = keyof typeof CollectorParamsArchiveType
/**
 * Справочник типа архивности показаний.
 * Используется для указания за какой период произошло измерение
 */
export type CollectorParamsArchiveTypeRequestEnum = Exclude<CollectorParamsArchiveTypeResponseEnum, "ARCHIVE_TYPE_UNKNOWN">;

/**
 * Справочник типов измерений
 */
export enum CollectorParamsSignType {
  /**
   * Значение не указано
   */
  SIGN_TYPE_UNKNOWN = "SIGN_TYPE_UNKNOWN",
  /**
   * Абсолютный показатель
   */
  ABSOLUTE_DS = "ABSOLUTE_DS",
  /**
   * Абсолютный расход ресурса
   */
  ABSOLUTE_RC = "ABSOLUTE_RC",
  /**
   * Интервальный показатель состояния
   */
  INTERVAL_DS = "INTERVAL_DS",
  /**
   * Интервальный расход ресурса
   */
  INTERVAL_RC = "INTERVAL_RC",
  /**
   * Текущее состояние
   */
  CURRENT_DS = "CURRENT_DS",
  /**
   * Текущее состояние ресурса
   */
  CURRENT_RS = "CURRENT_RS",
  /**
   * Объём
   */
  VOLUME = "VOLUME",
  /**
   * Параметр конфигурации
   */
  PARAMETER = "PARAMETER",
  /**
   * Флаг состояния
   */
  FLAG = "FLAG",
}
/**
 * Справочник типов измерений
 */
export type CollectorParamsSignTypeResponseEnum = keyof typeof CollectorParamsSignType
/**
 * Справочник типов измерений
 */
export type CollectorParamsSignTypeRequestEnum = Exclude<CollectorParamsSignTypeResponseEnum, "SIGN_TYPE_UNKNOWN">;

/**
 * Параметры сбора показаний
 */
export type CollectorParamsRequestDto = {
  /**
   * Дата в формате YYYYMMDD.
   * При пустой дате запускается на текущую дату
   */
  date?: string
  /**
   * Тип архивности.
   * При отсутствии переданного значения, будут запрошены показания по всем возможным типам архивности
   */
  archiveType?: CollectorParamsArchiveTypeRequestEnum | "ARCHIVE_TYPE_UNKNOWN"
  /**
   * Tип измерений.
   * При отсутствии переданного значения, будут запрошены показания по всем возможным типам измерений
   */
  signType?: CollectorParamsSignTypeRequestEnum | "SIGN_TYPE_UNKNOWN"
}
/**
 * Параметры сбора показаний
 */
export type CollectorParamsResponseDto = {
  /**
   * Дата в формате YYYYMMDD.
   * При пустой дате запускается на текущую дату
   */
  date: string
  /**
   * Тип архивности.
   * При отсутствии переданного значения, будут запрошены показания по всем возможным типам архивности
   */
  archiveType: CollectorParamsArchiveTypeResponseEnum
  /**
   * Tип измерений.
   * При отсутствии переданного значения, будут запрошены показания по всем возможным типам измерений
   */
  signType: CollectorParamsSignTypeResponseEnum
}
/**
 * Сигнал на старт сбора показаний Enviro по всем домам, на указанную дату.
 * Очередь key.telemetry_control.eic_all_fias_start_task
 */
export type EICAllFiasStartTaskRequestDto = {
  /**
   * Параметры сбора показаний
   */
  collectorParams: CollectorParamsRequestDto
}
/**
 * Сигнал на старт сбора показаний Enviro по всем домам, на указанную дату.
 * Очередь key.telemetry_control.eic_all_fias_start_task
 */
export type EICAllFiasStartTaskResponseDto = {
  /**
   * Параметры сбора показаний
   */
  collectorParams: CollectorParamsResponseDto
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Параметры сбора показаний
   */
  "CollectorParams": {
    "kind": "class",
    "text": "Параметры сбора показаний",
    "fields": {
      /**
       * Дата в формате YYYYMMDD.
       * При пустой дате запускается на текущую дату
       */
      "date": {
        "type": "string",
        "text": "Дата в формате YYYYMMDD.\nПри пустой дате запускается на текущую дату",
      },
      /**
       * Тип архивности.
       * При отсутствии переданного значения, будут запрошены показания по всем возможным типам архивности
       */
      "archiveType": {
        "type": "CollectorParams.ArchiveType",
        "text": "Тип архивности.\nПри отсутствии переданного значения, будут запрошены показания по всем возможным типам архивности",
      },
      /**
       * Tип измерений.
       * При отсутствии переданного значения, будут запрошены показания по всем возможным типам измерений
       */
      "signType": {
        "type": "CollectorParams.SignType",
        "text": "Tип измерений.\nПри отсутствии переданного значения, будут запрошены показания по всем возможным типам измерений",
      },
    },
  },
  /**
   * Сигнал на старт сбора показаний Enviro по всем домам, на указанную дату.
   * Очередь key.telemetry_control.eic_all_fias_start_task
   */
  "EICAllFiasStartTask": {
    "kind": "class",
    "text": "Сигнал на старт сбора показаний Enviro по всем домам, на указанную дату.\nОчередь key.telemetry_control.eic_all_fias_start_task",
    "fields": {
      /**
       * Параметры сбора показаний
       */
      "collectorParams": {
        "type": "CollectorParams",
        "text": "Параметры сбора показаний",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типа архивности показаний.
   * Используется для указания за какой период произошло измерение
   */
  "CollectorParams.ArchiveType": {
    "kind": "enum",
    "text": "Справочник типа архивности показаний.\nИспользуется для указания за какой период произошло измерение",
    "values": {
      /**
       * Значение не указано
       */
      "ARCHIVE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Текущие показания
       */
      "CURRENT": {
        "i": 1,
        "text": "Текущие показания",
      },
      /**
       * За 30 мин
       */
      "HALFHOUR": {
        "i": 2,
        "text": "За 30 мин",
      },
      /**
       * За час
       */
      "HOUR": {
        "i": 3,
        "text": "За час",
      },
      /**
       * За сутки
       */
      "DAY": {
        "i": 4,
        "text": "За сутки",
      },
      /**
       * За месяц
       */
      "MONTH": {
        "i": 5,
        "text": "За месяц",
      },
      /**
       * За год
       */
      "YEAR": {
        "i": 6,
        "text": "За год",
      },
    },
  },
  /**
   * Справочник типов измерений
   */
  "CollectorParams.SignType": {
    "kind": "enum",
    "text": "Справочник типов измерений",
    "values": {
      /**
       * Значение не указано
       */
      "SIGN_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Абсолютный показатель
       */
      "ABSOLUTE_DS": {
        "i": 1,
        "text": "Абсолютный показатель",
      },
      /**
       * Абсолютный расход ресурса
       */
      "ABSOLUTE_RC": {
        "i": 2,
        "text": "Абсолютный расход ресурса",
      },
      /**
       * Интервальный показатель состояния
       */
      "INTERVAL_DS": {
        "i": 3,
        "text": "Интервальный показатель состояния",
      },
      /**
       * Интервальный расход ресурса
       */
      "INTERVAL_RC": {
        "i": 4,
        "text": "Интервальный расход ресурса",
      },
      /**
       * Текущее состояние
       */
      "CURRENT_DS": {
        "i": 5,
        "text": "Текущее состояние",
      },
      /**
       * Текущее состояние ресурса
       */
      "CURRENT_RS": {
        "i": 6,
        "text": "Текущее состояние ресурса",
      },
      /**
       * Объём
       */
      "VOLUME": {
        "i": 7,
        "text": "Объём",
      },
      /**
       * Параметр конфигурации
       */
      "PARAMETER": {
        "i": 8,
        "text": "Параметр конфигурации",
      },
      /**
       * Флаг состояния
       */
      "FLAG": {
        "i": 9,
        "text": "Флаг состояния",
      },
    },
  },
}